# See guide/hacks/russian
CYRILLIC_QWERTY =
  "й": "Q"
  "ц": "W"
  "у": "E"
  "к": "R"
  "е": "T"
  "н": "Y"
  "г": "U"
  "ш": "I"
  "щ": "O"
  "з": "P"
  #"х": "[" # Not currently used for a shortcut
  #"ъ": "]" # Not currently used for a shortcut
  "ф": "A"
  "ы": "S"
  "в": "D"
  "а": "F"
  "п": "G"
  "р": "H"
  "о": "J"
  "л": "K"
  "д": "L"
  "ж": ";"
  #"э": "'" # Not currently used for a shortcut
  "я": "Z"
  "ч": "X"
  "с": "C"
  "м": "V"
  "и": "B"
  "т": "N"
  "ь": "M"
  "б": "Comma"
  "ю": "Period"

cyrillicCharCodeToKeyName = {}
for cyrillic, keyName of CYRILLIC_QWERTY
  cyrillicCharCodeToKeyName[cyrillic.charCodeAt(0)] = keyName

module.exports = cyrillicCharCodeToKeyName



// WEBPACK FOOTER //
// ./app/scripts/data/russian-keyboard.coffee